module.exports = __webpack_public_path__ + "static/assets/2f479bb9e2f68559c3ff7e5e458776ad.png";